var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VDataTable',{attrs:{"headers":_vm.headers,"items":_vm.items},scopedSlots:_vm._u([{key:"item.recruitment",fn:function(ref){
var item = ref.item;
return [_c('a',{attrs:{"href":("https://admin.job-tree-japan.com/#/recruitments/" + (item.recruitment_id)),"target":"_blank"}},[_vm._v(" "+_vm._s(item.recruitment_name)+" ")])]}},{key:"item.hf_member",fn:function(ref){
var item = ref.item;
return [_c('ApplicationChangeHfMemberForm',{staticClass:"mb-5",attrs:{"application":item.application}})]}},{key:"item.link",fn:function(ref){
var item = ref.item;
return [_c('VBtn',{on:{"click":function($event){return _vm.$router.push({name: 'ApplicationShowPage', params: { id: item.id }})}}},[_vm._v("詳細へ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }